import { Typography } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import Api from "../API/api";
import { loginState, WHState } from "../Atom/AtomState";
import "../CSS/PageCSS/ConsultPage.css";
import AlertComponent from "../CommonComponent/Alert/AlertComponent";
import ButtonComponent from "../CommonComponent/Inputs/ButtonComponent";
import SelectComponent from "../CommonComponent/Inputs/SelectComponent";
import TextComponent from "../CommonComponent/Inputs/TextComponent";
import Loading from "../CommonComponent/LoadingBar/Loading";
import PublicModal from "../CommonComponent/Modal/PublicModal";
import TableComponent from "../CommonComponent/Tables/TableComponent";

const { Title } = Typography;

export default function ConsultPage() {
  let navigate = useNavigate();
  const WH = useRecoilValue(WHState);
  const LoginState = useRecoilValue(loginState);
  const [divboxHeight, setdivBoxHeight] = useState<number>(0);
  const [searchInformation, setSearchInformation] = useState({
    type: "1",
    name: "",
    consultname: "",
    finyn: "1",
  });
  const [consultData, setConsultData] = useState<any>();
  const [alert, setAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [deleteModal, setDeleteModal] = useState({
    value: false,
    p_id: 0,
  });
  const [loading, setLoading] = useState(false);

  const changeTextField = (value: any) => {
    if (value.name == "name") {
      setSearchInformation((prev) => ({
        ...prev,
        name: value.value,
      }));
    } else if (value.name == "consultname") {
      setSearchInformation((prev) => ({
        ...prev,
        consultname: value.value,
      }));
    }
  };

  const changeSelect = (value: any) => {
    if (value.name == "type") {
      setSearchInformation((prev: any) => ({
        ...prev,
        type: value.value,
      }));
    } else if (value.name == "finyn") {
      setSearchInformation((prev: any) => ({
        ...prev,
        finyn: value.value,
      }));
    }
  };

  const handleSearch = () => {
    if (searchInformation.type == "1") {
      const getData = async () => {
        setLoading(true);
        const consult = await Api.get(
          `/Consult/getSearchFinyn?finyn=${searchInformation.finyn}`
        );
        setLoading(false);
        if (consult != undefined) {
          setConsultData(consult);
        } else {
          setAlert(true);
          setAlertMessage("데이터 조회에 실패하였습니다.");
        }
      };
      getData();
    } else if (searchInformation.type == "2") {
      const getData = async () => {
        setLoading(true);
        const consult = await Api.get(
          `/Consult/getSearchEmployee?name=${searchInformation.consultname}`
        );
        setLoading(false);
        if (consult != undefined) {
          setConsultData(consult);
        } else {
          setAlert(true);
          setAlertMessage("데이터 조회에 실패하였습니다.");
        }
      };
      getData();
    } else if (searchInformation.type == "3") {
      const getData = async () => {
        setLoading(true);
        const consult = await Api.get(
          `/Consult/getSearchCustomer?name=${searchInformation.name}`
        );
        setLoading(false);
        if (consult != undefined) {
          setConsultData(consult);
        } else {
          setAlert(true);
          setAlertMessage("데이터 조회에 실패하였습니다.");
        }
      };
      getData();
    }
  };

  const handleDelete = (item: any) => {
    const getDelete = async () => {
      setLoading(true);
      const deletedata = await Api.delete(
        `/Consult/deleteConsult?p_id=${item}`
      );
      setLoading(false);
      if (deletedata != undefined) {
        navigate(0);
      } else {
        setAlert(true);
        setAlertMessage("컨설팅 삭제에 실패하였습니다.");
      }
    };
    getDelete();
  };

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const consult = await Api.get("/Consult/getConsultList");
      setLoading(false);
      if (consult != undefined) {
        setConsultData(consult);
      } else {
        setAlert(true);
        setAlertMessage("데이터 조회에 실패하였습니다.");
      }
    };
    getData();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const div = document.getElementById("divbox") as HTMLElement;
      const ConsultSearchTextDiv = document.getElementById(
        "ConsultSearchTextDiv"
      ) as HTMLElement;
      if (div && ConsultSearchTextDiv) {
        setdivBoxHeight(
          div.clientHeight - ConsultSearchTextDiv.clientHeight - 20
        );
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  });

  return (
    <div style={{ height: WH.height - 160 }}>
      <Title level={2} className="ConsultTitle">
        ConsultPage
      </Title>
      <div id="divbox">
        <div className="ConsultSearchTextDiv" id="ConsultSearchTextDiv">
          <SelectComponent
            variant="filled"
            value={searchInformation.type}
            label={"검색조건"}
            name="type"
            menulist={[
              {
                p_id: "1",
                type: "완료여부",
              },
              {
                p_id: "2",
                type: "컨설턴트성함",
              },
              {
                p_id: "3",
                type: "고객성함",
              },
            ]}
            menuvalue="type"
            onChange={changeSelect}
            className="ConsultSearch"
          />
          {searchInformation.type == "1" ? (
            <SelectComponent
              variant="filled"
              value={searchInformation.finyn}
              label={"완료여부"}
              name="finyn"
              menulist={[
                {
                  p_id: "1",
                  type: "전체",
                },
                {
                  p_id: "2",
                  type: "미완료",
                },
                {
                  p_id: "3",
                  type: "완료",
                },
              ]}
              menuvalue="type"
              onChange={changeSelect}
              className="ConsultSearch"
            />
          ) : (
            <TextComponent
              variant="filled"
              value={
                searchInformation.type == "2"
                  ? searchInformation.consultname
                  : searchInformation.type == "3"
                  ? searchInformation.name
                  : ""
              }
              label={"성함"}
              name={
                searchInformation.type == "2"
                  ? "consultname"
                  : searchInformation.type == "3"
                  ? "name"
                  : ""
              }
              placeholder="검색어를 입력해주세요."
              onChange={changeTextField}
              className="ConsultSearch"
            />
          )}
          <ButtonComponent
            fullWidth
            variant="contained"
            className="ConsultsearchTextDiv_searchButton"
            onClick={handleSearch}
          >
            검색
          </ButtonComponent>
        </div>
        <TableComponent
          data={consultData}
          columns={
            LoginState?.manager
              ? [
                  {
                    width: "100px",
                    header: "고객",
                    field: "name",
                    position: "center",
                  },
                  {
                    width: "100px",
                    header: "컨설턴트",
                    field: "employee",
                    position: "center",
                  },
                  {
                    width: "100px",
                    header: "완료여부",
                    field: "finyn",
                    position: "center",
                    type: "CheckBoxReadOnly",
                  },
                  {
                    width: "100px",
                    header: "",
                    field: "UpdateButton",
                    position: "center",
                    type: "Button",
                    buttonLabel: "수정",
                    backgroundColor: "rgb(28, 128, 211)",
                  },
                  {
                    width: "100px",
                    header: "",
                    field: "CancelButton",
                    position: "center",
                    type: "Button",
                    buttonLabel: "삭제",
                    backgroundColor: "rgb(148, 148, 148)",
                  },
                ]
              : [
                  {
                    width: "100px",
                    header: "고객",
                    field: "name",
                    position: "center",
                  },
                  {
                    width: "100px",
                    header: "컨설턴트",
                    field: "employee",
                    position: "center",
                  },
                  {
                    width: "100px",
                    header: "완료여부",
                    field: "finyn",
                    position: "center",
                    type: "CheckBoxReadOnly",
                  },
                  {
                    width: "100px",
                    header: "",
                    field: "UpdateButton",
                    position: "center",
                    type: "Button",
                    buttonLabel: "수정",
                    backgroundColor: "rgb(28, 128, 211)",
                  },
                ]
          }
          scrollable={false}
          scrollHeight={divboxHeight}
          className="ConsultTable"
          onButtonClick={(row, id) => {
            if (id == "UpdateButton") {
              navigate("/ConsultDetailPage", {
                state: { p_id: row.p_id, state: "update" },
              });
            } else if (id == "CancelButton") {
              setDeleteModal({
                value: true,
                p_id: row.p_id,
              });
            }
          }}
          onClick={(row) => {
            navigate("/ConsultDetailPage", {
              state: { p_id: row.p_id, state: "view" },
            });
          }}
        />
      </div>
      {deleteModal && (
        <PublicModal
          open={deleteModal.value}
          onClose={(value: any) => {
            if (value) {
              handleDelete(deleteModal.p_id);
            }
            setDeleteModal({
              value: false,
              p_id: 0,
            });
          }}
          message={"삭제하시겠습니까?"}
          cancel={true}
        />
      )}
      {alert && (
        <AlertComponent value={alert} setValue={setAlert} info="error">
          {alertMessage}
        </AlertComponent>
      )}
      {loading && <Loading />}
    </div>
  );
}
